import React, { useCallback, useEffect, useState } from "react";
import isArray from "lodash/isArray";
import { useDropzone } from "react-dropzone"
import { Trash, Image } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";

import "../multipe-upload/style.scss";

export const DefaultIcon = () => <svg style={{ minWidth: 20 }} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M12.5 6.66666H12.5083" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M14.1668 3.33334H5.8335C4.45278 3.33334 3.3335 4.45263 3.3335 5.83334V14.1667C3.3335 15.5474 4.45278 16.6667 5.8335 16.6667H14.1668C15.5475 16.6667 16.6668 15.5474 16.6668 14.1667V5.83334C16.6668 4.45263 15.5475 3.33334 14.1668 3.33334Z" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M3.3335 12.5L6.66683 9.16666C7.04688 8.80096 7.47799 8.60843 7.91683 8.60843C8.35567 8.60843 8.78678 8.80096 9.16683 9.16666L13.3335 13.3333" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	<path d="M11.6665 11.6667L12.4998 10.8333C12.8799 10.4676 13.311 10.2751 13.7498 10.2751C14.1887 10.2751 14.6198 10.4676 14.9998 10.8333L16.6665 12.5" stroke="#555D67" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>;



const formatBytes = (bytes, decimals = 2) => {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};


const Upload = ({ label, type, values, name, setFieldValue, disabled = false, isBusiness }) => {

	const [warningMsg, setWarning] = useState("");
	const [local, setLocal] = useState(isArray(values[name]) ? values[name] : [values[name]]);

	useEffect(() => {
		setFieldValue(name, values[name]);
		setLocal(isArray(values[name]) ? values[name] : [values[name]]);
	}, [values[name]]);

	const onDrop = useCallback((accepted, rejected) => {

		if (Object.keys(rejected).length !== 0) {
			setWarning("Please submit valid file type");
		} else {

			if (accepted.length) {
				let updated = [];
				updated.push(Object.assign(accepted[0], {
					preview: URL.createObjectURL(accepted[0])
				}));
				setLocal(updated);
				setFieldValue(name, accepted[0]);
			} else {
				setFieldValue(name, []);
			}

			setWarning("");
		}
	}, []);

	const removeImage = () => {
		setFieldValue(name, []);
		setLocal([]);
	};

	const getOptions = () => {
		if (type === 'image') {
			return { accept: "image/*", disabled: disabled };
		}

		if (type === 'asset file') {
			return {
				accept: 'image/png, image/gif, image/jpg, image/jpeg, image/x-icon, image/vnd.microsoft.icon, .css, .js',
				disabled: disabled };
		}

		return {};
	}

	const { getRootProps, getInputProps } = useDropzone({
		onDrop: onDrop,
		multiple: false,
		...getOptions()
	});

	const thumbs = local.map((file, key) => {
		if(file) {
			return (
				<aside key={key} className="multipe-uploader-thumb">
					{!['js', 'css'].includes((file.name || "").split('.').pop()) ? (
						<div className="multipe-uploader-thumb-image">
							<img src={file.preview} alt={file.name} />
						</div>
					) : null}
					<div className="multipe-uploader-thumb-info">
						<div className="multipe-uploader-thumb-info-details">
							<span className="multipe-uploader-thumb-name">{file.name}</span>
							<span className="multipe-uploader-thumb-size">
								{file.size ? formatBytes(file.size) : file.date ? file.size : ''}
							</span>
						</div>
						<div className="multipe-uploader-remove-icon">
							<div className="cursor-pointer" onClick={() => removeImage(key)}><Trash /></div>
						</div>
					</div>
				</aside>
			)
		} else {
			return <div key={key}/>
		}
	});


	let areaProps = getRootProps();
	let inputProps = getInputProps();

	const uploader = <div {...areaProps} className="multipe-uploader-area">
		<input {...inputProps} />
		{type !== 'asset file' ? <Image /> : null}
		<div className="multipe-uploader-placeholder">
			<span>Click to Upload</span> or Drag n Drop {type !== 'asset file' ? 'Image' : 'File'}
			<div>
				{type !== 'asset file' ? `Files Supported: JPEG, PNG, Gif (max ${isBusiness ? 500 : 20} Mb)` : `Files Supported: JPEG, PNG, Gif, CSS, JS (max ${isBusiness ? 500 : 20} Mb)`}
			</div>
		</div>
		<div className="multipe-uploader-warning">{warningMsg}</div>
	</div>;

	return (
		<div className="mb-4">
			{label ? <label className="paylixecommerce-label">{label}</label> : null}
			<div className="multipe-uploader">
				{local.length ? null : uploader}
				{thumbs}

				<input {...inputProps} />
			</div>
		</div>
	);

}

export default Upload;
